import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

export interface PeriodicElement {
  taxId: string;
  address: string;
  country: string;
  name: string;
  economicActivity: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {
    taxId: '423809234',
    address: 'Avenida Lima 123, Chorrillos, Lima, Lima',
    country: 'PERU',
    name: 'ALICES COSMETICOS E.I.R.L',
    economicActivity: 'MEDICAMENTOS',
  },
  {
    taxId: '423809234',
    address: 'Avenida Lima 123, Chorrillos, Lima, Lima',
    country: 'PERU',
    name: 'ALICES COSMETICOS E.I.R.L',
    economicActivity: 'MEDICAMENTOS',
  },
  {
    taxId: '423809234',
    address: 'Avenida Lima 123, Chorrillos, Lima, Lima',
    country: 'PERU',
    name: 'ALICES COSMETICOS E.I.R.L',
    economicActivity: 'MEDICAMENTOS',
  },
  {
    taxId: '423809234',
    address: 'Avenida Lima 123, Chorrillos, Lima, Lima',
    country: 'PERU',
    name: 'ALICES COSMETICOS E.I.R.L',
    economicActivity: 'MEDICAMENTOS',
  },
  {
    taxId: '423809234',
    address: 'Avenida Lima 123, Chorrillos, Lima, Lima',
    country: 'PERU',
    name: 'ALICES COSMETICOS E.I.R.L',
    economicActivity: 'MEDICAMENTOS',
  },
  {
    taxId: '423809234',
    address: 'Avenida Lima 123, Chorrillos, Lima, Lima',
    country: 'PERU',
    name: 'ALICES COSMETICOS E.I.R.L',
    economicActivity: 'MEDICAMENTOS',
  },
  {
    taxId: '423809234',
    address: 'Avenida Lima 123, Chorrillos, Lima, Lima',
    country: 'PERU',
    name: 'ALICES COSMETICOS E.I.R.L',
    economicActivity: 'MEDICAMENTOS',
  },
];
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'pulse-table',
  host: { class: 'pulse-table' },
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  @Input() displayedColumns: string[] = [
    'taxId',
    'address',
    'country',
    'name',
    'economicActivity',
  ];

  dataSource = ELEMENT_DATA;

  constructor() {}

  ngOnInit(): void {}
}
